export const polyfill = async function () {
  if (typeof Object.entries === 'undefined') {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const entries = await import('object.entries');
    entries.default.shim();
  }

  if (typeof Object.fromEntries === 'undefined') {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const fromEntries = await import('object.fromentries');
    Object.fromEntries = fromEntries.default;
  }

  if (typeof window.URLSearchParams === 'undefined') {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    await import('url-search-params-polyfill');
  }
  if (typeof window.IntersectionObserver === 'undefined') {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    await import('intersection-observer');
  }
  if (typeof Array.prototype.flatMap === 'undefined') {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    await import('array-flat-polyfill');
  }

  if (typeof window.Intl === 'undefined') {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    await import('intl');
  }
};
